import { render, staticRenderFns } from "./HistoryArchiveWizard.vue?vue&type=template&id=6c0393c2"
import script from "./HistoryArchiveWizard.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoryArchiveWizard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports